// extracted by mini-css-extract-plugin
export var hasFrame = "Hero-module--hasFrame--0a47f";
export var heroContainer = "Hero-module--heroContainer--20563";
export var mediaWrapper = "Hero-module--mediaWrapper--3bf06";